import { useState } from 'react';
import { useFedContent } from '../content';
import { buildNovaSchedule, moveNovaScheduleMatch } from './novaBracketEngine';

export default function NovaSchedule({ tour, bracket, isAdmin, fire }) {
  const saveTournament = useFedContent((state) => state.saveTournament);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState({});
  const [busy, setBusy] = useState(false);
  const schedule = buildNovaSchedule(bracket, editing ? draft : tour.matchSchedule);
  const save = async () => {
    setBusy(true);
    try {
      const current = useFedContent.getState().tournaments.find((item) => item.id === tour.id);
      if (!current) throw new Error('Турнир не найден');
      if (await saveTournament({ ...current, matchSchedule: draft })) {
        setEditing(false);
        fire('Расписание сохранено', 'success');
      } else fire('Не удалось сохранить расписание', 'error');
    } catch (error) { fire(error.message, 'error'); }
    finally { setBusy(false); }
  };
  return <section className="rounded-2xl border border-line bg-surface-2 p-5">
    <h3 className="font-display font-bold uppercase text-xl">Расписание групповой стадии</h3>
    <p className="text-fg-muted text-sm my-3">Начало в 09:30 · два матча параллельно · час на матч · время Казахстана (UTC+5). Порядок матчей задаёт администратор. Расписание плей-офф будет добавлено позже.</p>
    {isAdmin && !editing && <button type="button" className="fed-btn-ghost px-3 py-2 mb-3" onClick={() => { setDraft(tour.matchSchedule || {}); setEditing(true); }}>Изменить время игр</button>}
    {editing && <p className="text-fg-muted text-sm mb-3">Выберите номер в колонке «Очередь», чтобы перенести матч. Остальные матчи сдвинутся; время и площадки остаются у мест в расписании.</p>}
    <div className="overflow-x-auto">
      <table className="fed-tbl">
        <thead><tr>{editing && <th>Очередь</th>}<th>День</th><th>Время</th><th>Площадка</th><th>Матч</th><th>Команды</th></tr></thead>
        <tbody>{schedule.map((match) => <tr key={match.id}>
          {editing && <td><select aria-label={`Очередь ${match.id}`} disabled={busy} className="fed-input" value={schedule.findIndex((item) => item.id === match.id)} onChange={(event) => setDraft({ ...draft, ...moveNovaScheduleMatch(schedule, match.id, Number(event.target.value)) })}>{schedule.map((item, index) => <option key={item.id} value={index}>{index + 1}</option>)}</select></td>}
          <td>{editing ? <input aria-label={`День ${match.id}`} className="fed-input" style={{ width: 80 }} type="number" min="1" max="365" required value={match.day} onChange={(event) => setDraft({ ...draft, [match.id]: { ...draft[match.id], day: Math.max(1, Math.min(365, Number(event.target.value) || 1)), time: match.time } })} /> : match.day}</td>
          <td>{editing ? <input aria-label={`Время ${match.id}`} className="fed-input" type="time" required value={match.time} onChange={(event) => { if (event.target.value) setDraft({ ...draft, [match.id]: { ...draft[match.id], day: match.day, time: event.target.value } }); }} /> : match.time}</td>
          <td>{match.stream}</td>
          <td>{match.group ? `Группа ${match.group} · ` : ''}{match.label}</td>
          <td>{bracket.names[match.a] || match.aSource.label} — {bracket.names[match.b] || match.bSource.label}</td>
        </tr>)}</tbody>
      </table>
    </div>
    {editing && <div className="flex gap-3 mt-3">
      <button type="button" disabled={busy} className="fed-btn-primary px-3 py-2" onClick={save}>{busy ? 'Сохранение…' : 'Сохранить расписание'}</button>
      <button type="button" disabled={busy} className="fed-btn-ghost px-3 py-2" onClick={() => setEditing(false)}>Отмена</button>
    </div>}
  </section>;
}
